/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelMicroAuthCheckRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'
import {CancelMicroAuthCheckResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'


export const cancelMicroAuthCheck = (request:CancelMicroAuthCheckRequest, options?: CashRequestOptions) => post<CancelMicroAuthCheckRequest, CancelMicroAuthCheckResponse>("/2.0/cash/cancel-micro-auth-check", request, {...options, rejectOnError: true })